import Constant from "../constants";
import { mainWrapper } from "./main";

const NewsService = {
    newsListing,
    newsDetail,
    newsCategories,
};

function newsListing(params) {
    return mainWrapper.get(Constant.host + "/news",params);
}

function newsDetail(id) {
    return mainWrapper.get(Constant.host + `/news/detail/${id}`);
}

function newsCategories() {
    return mainWrapper.get(Constant.host + "/news-categories");
}

export default NewsService;
